import { styled } from '@/styled-system/jsx';

import { Page } from '@zillow/constellation-10';

// The following styles are targeting classNames that are created within the shared zillow/zrs-zillow-offers ErrorPage component.

export const StyledPage = styled(Page.Root, {
  base: {
    margin: '0 auto !important',
    paddingBottom: '0',

    '& .testing_heading': {
      fontSize: '34px',
      lineHeight: '42px',
      lg: {
        fontSize: '60px',
        lineHeight: '72px',
      },
    },

    '&& [class^="Page__PageContent"]': {
      display: 'flex',
      minHeight: '100vh',
      position: 'relative',
    },

    '&& [class^="ErrorPage__CatWrapper"]': {
      width: '100%',
    },

    '&& [class^="ErrorPage__ContentWrapper"]': {
      width: '100%',
      maxWidth: '1232px',
    },
  },
});
